const onContactPageMatch = async (pathname, regex) => {
  // Extract contact ID from URL
  const contactIdMatch = pathname.match(/\/edit-person\/(\d+)/)
  const contactId = contactIdMatch ? contactIdMatch[1] : null

  if (!contactId) {
    return
  }

  // Wait for the ContactEditing class and #person div to be available using MutationObserver
  const initializeTaxNumberField = () => {
    const contactEditing = document.querySelector('.ContactEditing')
    const personDiv = document.querySelector('#person')

    if (!contactEditing || !personDiv) {
      return false
    }

    // Check if the field already exists to avoid duplicates
    const existingField = personDiv.querySelector('[data-field-name="taxNumber"]')
    if (existingField) {
      return true
    }

    // Find the sub-section-content div within #person
    const subSectionContent = personDiv.querySelector('.sub-section-content')
    if (!subSectionContent) {
      return false
    }

    // Find the last sub-section-content-row to insert after
    const rows = subSectionContent.querySelectorAll('.sub-section-content-row')
    const lastRow = rows[rows.length - 1]

    if (!lastRow) {
      return false
    }

    // Create a new row for the tax number field
    const newRow = document.createElement('div')
    newRow.className = 'sub-section-content-row'
    newRow.innerHTML = `
      <div class="sub-section-content-column" style="min-width: 25rem;">
        <div class="TextInput " data-field-name="taxNumber">
          <div class="ant-row ant-form-item ant-form-item-has-success" style="row-gap: 0px;">
            <div class="ant-col ant-form-item-label">
              <label class="" title="">
                <span><span>Steuernummer / UStId-Nr</span></span>
              </label>
            </div>
            <div class="ant-col ant-form-item-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content">
                  <input 
                    class="ant-input ant-input-status-success Input" 
                    placeholder="Bitte ausfüllen..." 
                    type="text" 
                    value=""
                    name="taxNumber"
                    data-field-name="taxNumber"
                  />
                </div>
              </div>
              <div class="ant-form-item-explain ant-form-item-explain-connected">
                <div role="alert" class="" style=""></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-section-content-column" style="min-width: 25rem;">
      </div>
    `

    // Insert the new row after the last row
    lastRow.parentNode.insertBefore(newRow, lastRow.nextSibling)

    // Set up input change handler to sync with form state
    const taxInput = newRow.querySelector('input[data-field-name="taxNumber"]')

    // Disable input until data is loaded
    taxInput.disabled = true
    taxInput.classList.add('ant-input-disabled')
    taxInput.placeholder = 'Lade...'

    // Load existing tax number from API
    const loadTaxNumber = async () => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token

        if (!token) {
          // Enable input even if token is missing
          taxInput.disabled = false
          taxInput.classList.remove('ant-input-disabled')
          taxInput.placeholder = 'Bitte ausfüllen...'
          return
        }

        const response = await fetch(
          `${baseApiUrl}/api/impowerX/contacts/tax-number?contactId=${contactId}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (response.ok) {
          const data = await response.json()
          if (data.taxNumber) {
            taxInput.value = data.taxNumber
          }
        }
      } catch (error) {
        console.error('Error loading tax number:', error)
      } finally {
        // Always enable input after load attempt (success or failure)
        taxInput.disabled = false
        taxInput.classList.remove('ant-input-disabled')
        taxInput.placeholder = 'Bitte ausfüllen...'
      }
    }

    // Load tax number after a short delay
    setTimeout(loadTaxNumber, 500)

    // Debounced save function
    let saveTimeout = null
    const saveTaxNumber = async (value) => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token

        if (!token) {
          return
        }

        const taxNumberValue = (value || taxInput.value || '').trim()

        const response = await fetch(
          `${baseApiUrl}/api/impowerX/contacts/tax-number`,
          {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              contactId: contactId,
              taxNumber: taxNumberValue || null,
            }),
          }
        )

        if (response.ok) {
          await response.json()
        }
      } catch (error) {
        // Error saving tax number
      }
    }

    // Set up debounced input change handler
    taxInput.addEventListener('input', (e) => {
      const value = e.target.value

      // Clear existing timeout
      if (saveTimeout) {
        clearTimeout(saveTimeout)
      }

      // Set new timeout to save after 1 second of no typing
      saveTimeout = setTimeout(() => {
        saveTaxNumber(value)
      }, 1000)
    })

    return true
  }

  // Try immediately in case elements are already present
  initializeTaxNumberField()

  // Set up MutationObserver to watch for DOM changes
  // Keep observer running so it can re-initialize the field if elements are removed/re-added during navigation
  const observer = new MutationObserver(() => {
    initializeTaxNumberField()
  })

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
